/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rateLimit': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M960 719.36h-64v-32a382.08 382.08 0 00-764.16 0v32h-64v-32a446.08 446.08 0 01892.16 0z" _fill="#212833"/><path pid="1" d="M489.792 664.704L710.4 444.096l45.248 45.248-220.608 220.64zM280.32 602.24l-60.16-22.08a291.84 291.84 0 0132-64l54.4 34.24a239.04 239.04 0 00-26.24 51.84zm64-96l-43.2-47.36a301.76 301.76 0 0159.2-42.88l32 55.68a237.44 237.44 0 00-47.68 34.24zm272.32-42.88a239.04 239.04 0 00-55.36-18.24l12.48-64a306.88 306.88 0 0169.76 22.72zM445.44 448l-16.96-61.76a291.2 291.2 0 0172.32-11.2l2.56 64a256 256 0 00-57.92 8.96zM201.92 655.68h64v64h-64zm621.76 63.68h-64v-64h64z" _fill="#212833"/>'
  }
})
